import { render, staticRenderFns } from "./labDataScore.vue?vue&type=template&id=375d4212"
import script from "./labDataScore.vue?vue&type=script&lang=ts"
export * from "./labDataScore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports